(() => {
  if (window.__sofsyClarityTagging) return;
  window.__sofsyClarityTagging = 1;

  const clarity = (...args) => {
    try {
      window.clarity?.(...args);
    } catch (_) {}
  };

  // These 8 Clarity events are unchanged by Round 6 (storefront #49), so their series carry on. Three of them have a
  // twin in assets/sofsy-track.js (size_selected, colour_swatch_clicked, checkout_clicked), which sends the twin to
  // Shopify's event bus only (clarity:false there), so Clarity counts each tap once, from here. Moving one to
  // sofsyTrack later = its registry flag there + deleting its line here. The theme's other events reach Clarity only
  // through sofsyTrack, behind Shopify's Customer Privacy API.
  const last = Object.create(null);
  const event = (name) => {
    const now = Date.now();
    if (now - (last[name] || 0) < 300) return;
    last[name] = now;
    clarity("event", name);
  };

  const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
  const CLICK_IDS = ["gclid", "fbclid", "ttclid", "msclkid"];
  const STORE_KEY = "sofsy_clarity_attr";
  const SOLD_OUT = ".product-unavailable__label, .product-unavailable__label-mobile, .out-of-stock";

  const ctx = (() => {
    try {
      const node = document.getElementById("clarity-ctx");
      return node ? JSON.parse(node.textContent) : {};
    } catch (_) {
      return {};
    }
  })();

  const params = new URLSearchParams(location.search);
  let saved = {};
  try {
    saved = JSON.parse(sessionStorage.getItem(STORE_KEY) || "{}");
  } catch (_) {}

  const utm = { ...(saved.utm || {}) };
  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) utm[key] = value;
  });

  let paid = saved.paid || "none";
  const clickType = CLICK_IDS.find((key) => params.get(key));
  if (clickType) paid = clickType;

  try {
    sessionStorage.setItem(STORE_KEY, JSON.stringify({ utm, paid }));
  } catch (_) {}

  UTM_KEYS.forEach((key) => {
    if (utm[key]) clarity("set", key, utm[key]);
  });
  clarity("set", "paid_click", paid);
  clarity("set", "page_type", ctx.pageType || "");
  clarity("set", "template", ctx.template || "");
  clarity("set", "logged_in", ctx.loggedIn ? "true" : "false");
  const cartCount = Number(ctx.cartCount) || 0;
  clarity("set", "cart_items", cartCount >= 3 ? "3+" : String(cartCount));
  clarity("set", "currency", window.Shopify?.currency?.active || ctx.currency || "");
  clarity("set", "country", window.Shopify?.country || "");

  if (ctx.loggedIn && ctx.customerId && crypto?.subtle) {
    crypto.subtle
      .digest("SHA-256", new TextEncoder().encode(String(ctx.customerId)))
      .then((buf) => {
        const hex = [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");
        clarity("identify", hex);
      })
      .catch(() => {});
  }

  const visible = (el) => !!(el && el.offsetParent);

  const inRect = (el, x, y) => {
    const r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  };

  const hitNoSizeAtc = (x, y) => {
    const stack = document.elementsFromPoint(x, y);
    for (const el of stack) {
      if (!el || el.tagName === "IFRAME" || el.id === "PBarNextFrame") continue;
      const overlay =
        (el.matches?.(".select-size-overlay") && el) ||
        el.closest?.(".select-size-overlay") ||
        el.querySelector?.(":scope > .select-size-overlay");
      const btn =
        (el.matches?.('button[name="add"]') && el) ||
        el.closest?.('button[name="add"]') ||
        el.querySelector?.(':scope > button[name="add"]') ||
        overlay?.closest?.('button[name="add"]');
      if (btn && btn.disabled && visible(btn) && inRect(btn, x, y)) return true;
    }
    return false;
  };

  document.addEventListener(
    "click",
    (e) => {
      try {
        // [data-pdp-size]: the Round 6 size pills (snippets/pdp-colour-size.liquid), <label for> the same inputs as
        // the [data-size] chips. They carry their own attribute because bundle.js indexes every [data-size].
        // [data-qd-pill]: the quantity drawer's size pills (assets/qty-drawer.js), so a size chosen in the drawer
        // counts in the same Clarity series as one chosen on the page (tracking lead, ITEM 17 option (b), 2 Oct).
        // They are buttons with no input behind them; a sold-out one carries aria-disabled="true" and counts as
        // size_unavailable_clicked. The bus twin (sofsyTrack size_selected, place 'drawer') is unchanged.
        const size = e.target.closest?.("[data-size], [data-pdp-size], [data-qd-pill]");
        if (size) {
          const input = size.htmlFor ? document.getElementById(size.htmlFor) : null;
          const unavailable =
            size.matches(SOLD_OUT) || size.getAttribute("aria-disabled") === "true" || !!(input && input.disabled);
          event(unavailable ? "size_unavailable_clicked" : "size_selected");
        }
        if (e.target.closest?.(".size-guide-opener")) event("size_guide_opened");
        if (e.target.closest?.(".color-swatch__item")) event("colour_swatch_clicked");
        if (e.target.closest?.('form[action="/cart"] button[name="checkout"].btn-primary')) {
          event("checkout_clicked");
        }
        if (hitNoSizeAtc(e.clientX, e.clientY)) event("pdp_no_size_selected_atc");
      } catch (_) {}
    },
    true
  );

  // Chrome dispatches no click for a disabled button, so the no-size add-to-cart
  // tap only reaches us as pointerdown. event() dedupes if a browser sends both.
  document.addEventListener(
    "pointerdown",
    (e) => {
      try {
        if (hitNoSizeAtc(e.clientX, e.clientY)) event("pdp_no_size_selected_atc");
      } catch (_) {}
    },
    true
  );

  document.addEventListener(
    "submit",
    (e) => {
      try {
        if (e.target.closest?.("product-form")) event("add_to_cart_clicked");
      } catch (_) {}
    },
    true
  );

  // Round 6 (Q01, Q-14): on phones and tablets the page's Add to Bag opens the quantity drawer and the tap that adds
  // is the drawer's own Add to Bag (assets/qty-drawer.js), a type="button" outside <product-form>, so it never
  // submits. add_to_cart_clicked keeps its meaning, "the tap that adds", from that button. A disabled button (an
  // empty drawer, or an add already running) dispatches no click, so it is never counted. Desktop still adds through
  // <product-form> (the submit above); the two never fire for one tap.
  document.addEventListener(
    "click",
    (e) => {
      try {
        if (e.target.closest?.("sofsy-qty-drawer [data-qd-add]")) event("add_to_cart_clicked");
      } catch (_) {}
    },
    true
  );

  const errorShown = (el) =>
    el?.nodeType === 1 &&
    el.matches?.(".product-form__error-message-wrapper") &&
    !el.hasAttribute("hidden") &&
    !!el.textContent.trim();

  try {
    new MutationObserver((records) => {
      for (const rec of records) {
        const node = rec.target;
        if (node?.nodeType !== 1) continue;
        const wrap = errorShown(node) ? node : node.closest?.(".product-form__error-message-wrapper");
        if (errorShown(wrap)) {
          event("add_to_cart_failed");
          return;
        }
      }
    }).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["hidden"],
    });
  } catch (_) {}
})();
